export const PIERS_MAIN_TOUR_VERSION = 1;
export const onboardingDismissedSessionKey = `piers-onboarding-dismissed-v${PIERS_MAIN_TOUR_VERSION}`;

export const dashboardOnboardingTour = [
  {
    id: "workspace",
    target: '[data-tour="workspace-selector"]',
    title: "Your Workspace",
    description:
      "Access the PIERS workspace available to you and switch between application areas when additional workspaces are enabled.",
    placement: "bottom",
  },
  {
    id: "dashboard",
    target: '[data-tour="dashboard-nav"]',
    title: "Your Inspection Overview",
    description:
      "Monitor inspection activity, risk, deadlines, review workload, queries and cycle progress from one place.",
    placement: "right",
  },
  {
    id: "clients",
    target: '[data-tour="clients-nav"]',
    title: "Manage Clients",
    description:
      "View and maintain the clients included in your inspection and review programs.",
    placement: "right",
  },
  {
    id: "inspection-cycle",
    target: '[data-tour="inspection-cycle-nav"]',
    title: "Inspection Cycles",
    description:
      "Plan and manage annual or periodic inspection cycles and track progress across the program.",
    placement: "right",
  },
  {
    id: "engagement",
    target: '[data-tour="engagement-nav"]',
    title: "Manage Engagements",
    description:
      "Create and manage engagements, assign teams, review types, scopes and checklists.",
    placement: "right",
  },
  {
    id: "engagement-review",
    target: '[data-tour="engagement-review-nav"]',
    title: "Perform Reviews",
    description:
      "Work through assigned reviews, checklist responses, supporting documents, queries, findings and sign-offs.",
    placement: "right",
  },
  {
    id: "review-tasks",
    target: '[data-tour="review-tasks-nav"]',
    title: "Your Review Tasks",
    description:
      "See work assigned to you, upcoming actions, overdue items and review responsibilities.",
    placement: "right",
  },
  {
    id: "data-import",
    target: '[data-tour="data-import-nav"]',
    title: "Import Data",
    description:
      "Bring clients, engagements and supported source data into PIERS through the guided import process.",
    placement: "right",
  },
  {
    id: "reports",
    target: '[data-tour="reports-nav"]',
    title: "Reports",
    description:
      "Access inspection, checklist and engagement reporting and review completed outputs.",
    placement: "right",
  },
  {
    id: "notifications",
    target: '[data-tour="notifications"]',
    title: "Stay Informed",
    description:
      "Receive notifications about assignments, queries, deadlines, review activity and completed background processes.",
    placement: "bottom",
  },
  {
    id: "help",
    target: '[data-tour="help"]',
    title: "Help Is Always Available",
    description:
      "Open Help whenever you need documentation, walkthroughs or want to restart the PIERS tour.",
    placement: "bottom",
  },
];
